import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Fingerprint01 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "fingerprint01",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6.9182 3.3857C8.4074 2.5051 10.1447 2 12 2c5.5228 0 10 4.4771 10 10 0 .0331-.0002.0662-.0005.0993M3.3811 6.9259C2.5035 8.4132 2 10.1479 2 12c0 4.6596 3.187 8.5748 7.5 9.685m11.2076-4.7644c-1.3204 2.3316-3.5502 4.0804-6.2076 4.7644m-.4107-15.3112A5.9871 5.9871 0 0 0 12 6c-3.3137 0-6 2.6863-6 6 0 .7387.1335 1.4463.3777 2.0999m11.2474-4.1922A5.9877 5.9877 0 0 1 18 12c0 3.3137-2.6863 6-6 6a5.9862 5.9862 0 0 1-2.0763-.369M12 10v4"
    })
  }));
};
export default Fingerprint01;